import React from 'react'

import { Container } from './Common'
import DatesVariant from './Common/DatesVariant'
import SummaryCardImage from './SummaryCardImage'

import TripItemSummary from 'tripPlanner/components/TripModal/TripItems/Summary'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { CarRentalItem } from 'tripPlanner/types/tripItem'
import { typeConstToTitle } from 'tripPlanner/utils'

interface Props {
  item: CarRentalItem
}

const CarRentalSummaryCard = React.forwardRef<HTMLDivElement, Props>(
  ({ item }, ref) => {
    const {
      startPlace,
      isBooked,
      carType,
      type,
      startDate,
      endDate,
      startDay,
      endDay,
    } = item

    const openModal = useOpenModal()

    const onClick = () => openModal(TripItemSummary, { item })
    const canEdit = useCanEditTrip()

    return (
      <Container ref={ref}>
        <SummaryCardImage
          place={startPlace}
          tripId={item.tripId}
          tripItemId={item.id}
        />
        <DatesVariant
          region={undefined}
          name={carType || typeConstToTitle(type)}
          startDate={startDate}
          endDate={endDate}
          isBooked={isBooked}
          type={type}
          onClick={onClick}
          canEdit={canEdit && !isBooked}
          startDay={startDay}
          endDay={endDay}
        />
      </Container>
    )
  },
)

export default CarRentalSummaryCard
